import { render, staticRenderFns } from "./services-icon.vue?vue&type=template&id=479a7c70&scoped=true&"
import script from "./services-icon.vue?vue&type=script&lang=ts&"
export * from "./services-icon.vue?vue&type=script&lang=ts&"
import style0 from "./services-icon.vue?vue&type=style&index=0&id=479a7c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a7c70",
  null
  
)

export default component.exports